import React, { useEffect } from "react";
import MinistrySteps from "../../components/HorizontalSteps/ministrySteps";
import { Link } from "react-router-dom";
import Api from "../../services/api";
import { ToastContainer, toast } from "react-toastify";
import { ADToBS } from "../../utils/dateUtils";
import DashboardFinal from "./dashboard/index";
const province_data = [
  "koshi",
  "madhesh",
  "bagmati",
  "gandaki",
  "lumbini",
  "karnali",
  "Sudurpashchim",
];
export default function MinistryDashboard() {
  const [activeStep, setActiveStep] = React.useState(1);
  const [mdata, setMdata] = React.useState();

  const PostStage = async (status) => {
    let response = await Api.submitProvincialStage({
      fiscal_year_id: JSON.parse(localStorage.getItem("user")).user
        .fiscal_year_id,
      status: status,
      ocmcm_id: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).user.ocmcm_id
        : sessionStorage.getItem("provinceId"),
      date: ADToBS(new Date()),
    });

    if (response.code === 200) {
      toast.success(response.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      getData();
    } else {
      toast.error(response.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };
  const getData = async () => {
    let response = await Api.getProvincialData({
      fiscal_year_id: JSON.parse(localStorage.getItem("user")).user
        .fiscal_year_id,

      ocmcm_id: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).user.ocmcm_id
        : sessionStorage.getItem("provinceId"),
      province_id: sessionStorage.getItem("provinceId"),
    });
    if (response.code === 200) {
      setMdata(response.response);
      sessionStorage.setItem("step_data", JSON.stringify(response.response));
      setActiveStep(
        response && response.response && response.response.status + 1
      );
      console.log(response);
      console.log(activeStep);
    } else {
      toast.error(response.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div>
        <ToastContainer />
        <MinistrySteps activeStep={activeStep} data={mdata} />

        <div>
          <Link
            to={`/selfevaluationform/${
              province_data[sessionStorage.getItem("provinceId") - 1]
            }`}
          >
            <button className="btn btn-success mr-2">फारममा जानुहोस </button>
          </Link>
          {/* &&  JSON.parse(localStorage.getItem("user")).user
        .role_id */}
          {activeStep === 1 && (
            <button
              className="btn btn-primary mr-2"
              onClick={() => PostStage(1)}
            >
              पेश गर्नुहोस
            </button>
          )}
          {activeStep === 2 && (
            <button
              className="btn btn-primary mr-2"
              onClick={() => PostStage(2)}
            >
              पेश गर्नुहोस
            </button>
          )}
          {activeStep === 3 &&
            JSON.parse(localStorage.getItem("user")).user.role_id === 12 && (
              <button
                className="btn btn-primary mr-2"
                onClick={() => PostStage(3)}
              >
                पृष्ठपोषण गर्नुहोस
              </button>
            )}
          {activeStep === 4 && (
            <button className="btn btn-primary" onClick={() => PostStage(4)}>
              सार्वजनिक गर्नुहोस
            </button>
          )}
        </div>
      </div>
      {activeStep === 5 && <DashboardFinal data={mdata} />}
    </>
  );
}
